
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ClassMetadata, IDocument, IGLDepositDeleteCriteria, IGLDepositSaveCriteria } from "@tylertech/tyler-api-types";

/**
 * GLDepositService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class GLDepositService<T = unknown> {
    constructor(private readonly $apiService: ApiService) { }
    
    DeleteDeposit(pCriteria: IGLDepositDeleteCriteria): Promise<boolean> {
        return this.$apiService.sendAuth("IGLDepositService/DeleteDeposit", pCriteria);
    }
    GetDeposits(filterString?: string): Promise<T[]> {
        return this.$apiService.sendAuth("IGLDepositService/GetDeposits", null, filterString);
    }
    GetGLDepositMetadata(): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IGLDepositService/GetGLDepositMetadata");
    }
    GetNewDeposit(): Promise<T> {
        return this.$apiService.sendAuth("IGLDepositService/GetNewDeposit");
    }
    PrintDeposit(pId: string): Promise<IDocument> {
        return this.$apiService.sendAuth("IGLDepositService/PrintDeposit", pId);
    }
    SaveDeposit(pCriteria: IGLDepositSaveCriteria): Promise<IGLDepositSaveCriteria> {
        return this.$apiService.sendAuth("IGLDepositService/SaveDeposit", pCriteria);
    }
}
